import { defineComponent as _defineComponent } from 'vue'
import ConfirmationDialog from "@/components/ConfirmationDialog.vue";
import { ClearMasterShiftsTeamAndPeriodDocument} from "owfsa-graphql";
import { useCurrSchedDataIdsStore } from "@/stores/currSchedDataIds.store";
import { useMutation } from "@urql/vue";
import { ref } from "vue";
import { toast } from "vue-sonner";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClearShifts',
  setup(__props, { expose: __expose }) {
  __expose();

const currSchedDataIdsStore = useCurrSchedDataIdsStore();
const clearShiftsMutation = useMutation(ClearMasterShiftsTeamAndPeriodDocument);

const showClearShiftDialog = ref(false);
const clearLockedShifts = ref(false);

async function clearShifts() {
  const result = await clearShiftsMutation.executeMutation({
    teamId: currSchedDataIdsStore.currTeamId,
    schedPeriodId: currSchedDataIdsStore.currSchedPeriodId,
    clearLockedShifts: clearLockedShifts.value,
  });

  if (!result.error && !!result.data) {
    toast.success("Shifts have been cleared successfully");
    showClearShiftDialog.value = false;
  } else {
    toast.error("Error has occurred while clearing shifts");
  }
}


const __returned__ = { currSchedDataIdsStore, clearShiftsMutation, showClearShiftDialog, clearLockedShifts, clearShifts, ConfirmationDialog }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})